exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".brand__wrap{line-height:0}.brand__typeface svg *{fill:#fff}.brand__logo svg *{-webkit-transition:fill .5s ease;transition:fill .5s ease}.brand__logo--filled svg *{fill:transparent!important}.brand--fill-white .brand__logo--filled svg *{fill:#fff!important}.brand--logo.brand--fill-white .brand__logo--colored svg *{fill:transparent!important}.brand__logo-wrap{position:relative}.brand__logo--colored{position:absolute;top:0;right:0;width:100%;height:100%}", ""]);

// exports
